module.exports = __webpack_public_path__ + "img/SteepTop.ea6328c5.png";